var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResultMarkSix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/24x24px/Result_MarkSix") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/24x24px/Result_MarkSix"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/24x24px/results-Copy-3",
    transform: "translate(3.500000, 2.946296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1190797,8.65084037 C23.8280939,8.65084037 23.8280939,9.65084037 23.1190797,9.65084037 L5.88092028,9.65084037 C5.17190608,9.65084037 5.17190608,8.65084037 5.88092028,8.65084037 L23.1190797,8.65084037 Z",
    id: "Line-Copy-2",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(14.500000, 9.150840) rotate(90.000000) translate(-14.500000, -9.150840) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,0.0537038722 L17,18.0537039 L0,18.0537039 L0,0.153703874 C-6.76353761e-18,0.0984753979 0.0447715257,0.0537038722 0.100000001,0.0537038722 L17,0.0537038722 L17,0.0537038722 Z",
    id: "Rectangle",
    stroke: "#333333",
    strokeWidth: 1.75,
    strokeLinejoin: "round",
    transform: "translate(8.500000, 9.053704) scale(-1, -1) translate(-8.500000, -9.053704) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(3.250000, 3.553704)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(2.000000, 0.100000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.52702703,0 C6.78824279,0 7,0.223857625 7,0.5 C7,0.776142375 6.78824279,1 6.52702703,1 L0.472972973,1 C0.211757213,1 0,0.776142375 0,0.5 C0,0.223857625 0.211757213,0 0.472972973,0 L6.52702703,0 Z",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52702703,2.40897959 C6.78824279,2.40897959 7,2.63283722 7,2.90897959 C7,3.18512197 6.78824279,3.40897959 6.52702703,3.40897959 L0.472972973,3.40897959 C0.211757213,3.40897959 0,3.18512197 0,2.90897959 C0,2.63283722 0.211757213,2.40897959 0.472972973,2.40897959 L6.52702703,2.40897959 Z",
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52702703,4.8 C6.78824279,4.8 7,5.02385763 7,5.3 C7,5.57614237 6.78824279,5.8 6.52702703,5.8 L0.472972973,5.8 C0.211757213,5.8 0,5.57614237 0,5.3 C0,5.02385763 0.211757213,4.8 0.472972973,4.8 L6.52702703,4.8 Z",
    id: "Line-Copy-2"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.625,
    cy: 0.625,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 0.625,
    cy: 3.025,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 0.625,
    cy: 5.425,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "barcode_FILL0_wght400_GRAD0_opsz48",
    transform: "translate(5.000000, 14.053704)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2 L0,0 L0.772727273,0 L0.772727273,2 L0,2 Z M1.09090909,2 L1.09090909,0 L1.81818182,0 L1.81818182,2 L1.09090909,2 Z M2.18181818,2 L2.18181818,0 L2.54545455,0 L2.54545455,2 L2.18181818,2 Z M3.27272727,2 L3.27272727,0 L4,0 L4,2 L3.27272727,2 Z M4.36363636,2 L4.36363636,0 L5.45454545,0 L5.45454545,2 L4.36363636,2 Z M5.81818182,2 L5.81818182,0 L6.18181818,0 L6.18181818,2 L5.81818182,2 Z M6.90909091,2 L6.90909091,0 L8,0 L8,2 L6.90909091,2 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultMarkSix);
export default __webpack_public_path__ + "static/media/result_MarkSix.71e5593831b4e26a3d927b328acf21b5.svg";
export { ForwardRef as ReactComponent };